import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Dialog from 'components/dialog'
import { PROMO_CALLOUT_BORDER_RADIUS } from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: PROMO_CALLOUT_BORDER_RADIUS,
  },
  dialogTitle: {
    padding: theme.spacing(1.5),
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  dialogContent: {
    padding: theme.spacing(1.5),
    paddingTop: 0,
  },
  section: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  sectionHeading: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    marginBottom: theme.spacing(0.5),
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(2.5),
  },
  listItem: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.primary,
  },
}))

export const eventRecommendationsConfig = [
  {
    id: 1,
    sectionTitle: 'Identify who the event is for',
    bullets: [
      'Is this event going to befor beginners or advanced golfers',
      'Is the event child and/or family friendly?',
      'Are there age restrictions? Will alcohol be served?',
    ],
  },
  {
    id: 2,
    sectionTitle: 'Do attendees need equipment',
    bullets: ['Include in your description if golf equipment is required'],
  },
  {
    id: 3,
    sectionTitle: 'What are the expectations?',
    bullets: [
      'Will attendees need to be ready to go onto the golf course?',
      'How many participants wil be attending (5 is a lot different than 50),',
      'How much 1-on-1 time will I have with the coach?',
    ],
  },
  {
    id: 4,
    sectionTitle: 'Are friends allowed to join?',
    bullets: [
      'Can attendees bring friends or family?',
      'Is the event for members of the club only?',
    ],
  },
  {
    id: 5,
    sectionTitle: "What's included?",
    bullets: [
      'Will attendees receive range balls, shop discount, food and/or alcohol?',
    ],
  },
  {
    id: 6,
    sectionTitle: 'Frequently asked questions',
    bullets: [
      'Include a list of commonly asked questions',
      'Provide contact information',
    ],
  },
]

export const offeringRecommendationsConfig = [
  {
    id: 1,
    sectionTitle: 'Identify who the offering is for',
    bullets: [
      'Is this offering going to be for beginners or advanced golfers',
      'Is the offering child and/or family friendly?',
      'Are there age restrictions? Will alcohol be served?',
    ],
  },
  {
    id: 2,
    sectionTitle: 'Do participants need equipment',
    bullets: ['Include in your description if golf equipment is required'],
  },
  {
    id: 3,
    sectionTitle: 'What are the expectations?',
    bullets: [
      'Will participants need to be ready to go onto the golf course?',
      'How many participants wil be attendting (5 is a lot different than 50),',
      'How much 1-on-1 time will I have with the coach?',
    ],
  },
  {
    id: 4,
    sectionTitle: 'Are friends allowed to join?',
    bullets: [
      'Can participants bring friends or family?',
      'Is the offering for members of the club only?',
    ],
  },
  {
    id: 5,
    sectionTitle: "What's included?",
    bullets: [
      'Will participants receive range balls, shop discount, food and/or alcohol?',
    ],
  },
  {
    id: 6,
    sectionTitle: 'Frequently asked questions',
    bullets: [
      'Include a list of commonly asked questions',
      'Provide contact information',
    ],
  },
]

const RecommendedDetailsDialog = ({
  title,
  recommendations,
  isOpen,
  onClose,
}) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))

  return (
    <Dialog
      fullScreen={isMobile}
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton
      maxWidth="sm"
      fullWidth
      classes={{ paper: classes.paper }}
    >
      {() => (
        <>
          <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            {recommendations.map(({ id, sectionTitle, bullets }) => (
              <div key={id} className={classes.section}>
                <Typography className={classes.sectionHeading} component="p">
                  {sectionTitle}
                </Typography>
                <ul className={classes.list}>
                  {bullets.map((listItem, index) => (
                    <li key={index}>
                      <Typography component="span" className={classes.listItem}>
                        {listItem}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}

export default RecommendedDetailsDialog
